import * as Sentry from "@sentry/react";

let initialized = false;

export function initSentryClient() {
  if (typeof window === "undefined" || initialized) return;
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  });
  initialized = true;
}

export function captureSentryException(error: unknown, context: Record<string, unknown>) {
  if (typeof window === "undefined") return;
  Sentry.captureException(error, { extra: context });
}
